module.exports = __webpack_public_path__ + "static/media/IMG_8730.8118b947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8730.jpg
// module id = 151
// module chunks = 0